import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['altNameInput'];

  show() {
    $(this.altNameInputTarget).show('fast');
  }

  hide() {
    $(this.altNameInputTarget).hide('fast');
  }
}
